import { Grid, Skeleton } from '@mui/material';

import { Fragment } from 'react';

const ActivationsSkeleton = () => {
  return (
    <Fragment>
      <Grid xs={12}>
        <Skeleton variant="text" width={300} height={50} />
        <Skeleton variant="text" width={450} height={30} />
      </Grid>
      <Grid xs={12} display="flex" spacing={2} gap={2}>
        {Array.from({ length: 5 }, (_, index) => (
          <Skeleton key={index} variant="rounded" width={300} height={310} />
        ))}
      </Grid>
    </Fragment>
  );
};
export default ActivationsSkeleton;
